const ITEMS = [
  "Bonés Importados",
  "Roupas Premium",
  "Pronta Entrega",
  "Encomendas",
  "+1.000 Clientes Atendidos",
  "Importados e Nacionais",
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((item, i) => (
      <span key={i} className="flex items-center">
        <span
          className={`whitespace-nowrap px-8 font-display text-2xl font-extrabold uppercase tracking-tight sm:text-3xl ${
            i % 2 === 0 ? "text-offwhite" : "text-stroke-faint"
          }`}
        >
          {item}
        </span>
        <span className="h-2 w-2 rotate-45 bg-silver/40" aria-hidden="true" />
      </span>
    ))}
  </div>
);

const Marquee = () => (
  <div data-testid="editorial-marquee" className="marquee-mask overflow-hidden border-y border-white/10 bg-graphite py-6">
    <div className="animate-marquee flex w-max">
      <Row />
      <Row />
    </div>
  </div>
);

export default Marquee;
